module.exports = __webpack_public_path__ + "static/img/sms-new-active.74c0590.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/sms-new-active.png
// module id = r0Ur
// module chunks = 26